/* Every user-facing string, Romanian first (docs/04 "Internationalisation"). Voice from the design
   system: short sentences, second person (tu), sentence case, no exclamation marks, no emoji,
   minutes never percentages, missing data stated. English keeps the same keys. */

export const ro = {
  // Shell
  'nav.menu': 'Meniu',
  'nav.card': 'Fidelitate',
  'nav.visit': 'Bon',
  'nav.account': 'Cont',
  'nav.label': 'Navigare',
  'header.lang': 'Schimbă limba',
  'header.notifications': 'Notificări',
  'header.account': 'Contul meu',
  'header.top': 'Sus',
  'common.back': 'Înapoi',
  'common.skip': 'Sari la conținut',
  'common.close': 'Închide',
  'common.retry': 'Încearcă din nou',
  'common.save': 'Salvează',
  'common.cancel': 'Renunță',
  'common.lei': 'lei',
  'common.min': 'min',
  'common.loading': 'Se încarcă…',
  'common.unavailable': 'Informație indisponibilă',
  'common.offlineNeeded': 'Ai nevoie de internet pentru asta.',
  'common.errorGeneric': 'Nu am putut face asta acum. Încearcă din nou peste un minut.',
  'update.available': 'Există o versiune nouă a aplicației.',
  'update.reload': 'Reîncarcă',

  // Crowding mini bar
  'mini.low': 'Coadă mică',
  'mini.moderate': 'Coadă medie',
  'mini.high': 'Coadă mare',
  'mini.closed': 'Închis',
  'mini.none': 'Fără estimare',

  // Closed labels
  'closed.today': 'azi la {time}',
  'closed.tomorrow': 'mâine la {time}',
  'closed.weekday': '{day} la {time}',
  'closed.unknown': 'în curând',

  // Home — picks, spotlights
  'home.picks': 'Ce mănâncă lumea azi',
  'home.picksMeta': 'după note',
  'home.spotRail': 'Noutăți',
  'home.spotDots': 'Alege cardul',
  'home.spotDot': 'Cardul {n} din {total}',
  'spot.offline.eyebrow': 'Fără internet',
  'spot.offline.title': 'Îți arătăm meniul salvat. Raportul pleacă singur când revine semnalul.',
  'spot.closed.eyebrow': 'Cantina e închisă',
  'spot.closed.title': 'Deschidem {when}. Meniul apare de obicei până la 10:30.',
  'spot.tip.eyebrow': 'Sfat pentru {weekday}',
  'spot.tip.title': 'La {quietTime} aștepți cam {quiet}. La {busyTime}, cam {busy}.',
  'spot.tip.action': 'Vezi orele',
  'spot.loyalty.eyebrow': 'Fidelitate',
  'spot.loyalty.title': 'Încă o vizită și următoarea masă e gratuită.',
  'spot.loyalty.action': 'Vezi cardul',
  'spot.reward.title': 'Ai o masă gratuită. Arată codul la casă.',
  'spot.report.eyebrow': 'Ajută-i pe colegi',
  'spot.report.title': 'Spune cât ai stat la coadă. Durează două secunde.',
  'spot.report.action': 'Raportez',
  'spot.alert.eyebrow': 'Meniul de mâine',
  'spot.alert.title': 'Apare de obicei până la 10:30. Îți dăm de știre.',
  'spot.alert.action': 'Anunță-mă',
  'spot.alert.on': 'Activat',
  'spot.feedback.eyebrow': 'Părerea ta',
  'spot.feedback.title': 'Patru întrebări, treizeci de secunde. Ne ajută să facem aplicația mai bună.',
  'spot.feedback.action': 'Răspund',

  // Menu
  'menu.title': 'Meniul de azi',
  'menu.filters': 'Filtre alimentare',
  'menu.seeAll': 'Vezi tot meniul',
  'menu.savedFilter': 'Filtrul tău salvat e aplicat.',
  'menu.staleLabel': 'Meniul de azi nu e publicat încă. Îți arătăm meniul din {date}.',
  'menu.empty.title': 'Meniul de azi nu e publicat încă',
  'menu.empty.body': 'De obicei apare până la 10:30. Revino puțin mai târziu.',
  'menu.noResults.title': 'Niciun fel nu se potrivește cu filtrele',
  'menu.noResults.body': 'Scoate un filtru ca să vezi tot meniul de azi.',
  'menu.noResults.action': 'Șterge filtrele',
  'menu.error.title': 'Nu am putut încărca meniul',
  'menu.error.body': 'Verifică internetul și încearcă din nou.',
  'menu.cached': 'Actualizat la {time}',

  // Loyalty zone
  'loyalty.addReceipt': 'Adaugă bon',

  // Wait report
  'report.title': 'Cât ai așteptat?',
  'report.other': 'Altă durată',
  'report.minutesLabel': 'Minute la coadă',
  'report.send': 'Trimite',
  'report.thanks': 'Mulțumim. Estimarea s-a actualizat.',
  'report.queued': 'Mulțumim. Raportul pleacă singur când revine semnalul.',
  'report.already': 'Ai raportat deja în ora asta. Mulțumim.',
  'report.closed': 'Rapoartele se trimit doar cât e deschisă cantina.',
  'report.rejected': 'Mulțumim. Raportul tău diferă mult de ce vede camera, așa că nu l-am folosit acum.',
  'report.invalid': 'Scrie un număr de minute între 0 și 120.',

  // Typical by hour
  'typical.title': 'De obicei {weekday}',
  'typical.busy': 'aglomerat la {busy}, liber la {quiet}',
  'typical.today': 'Azi, de obicei',
  'typical.none': 'Încă nu avem destule date ca să-ți arătăm orele aglomerate.',

  // Announcements
  'announce.until': 'până {date}',

  // Footer
  'footer.feedback': 'Trimite feedback',
  'footer.privacy': 'Confidențialitate',
  'footer.account': 'Contul meu',
  'footer.signIn': 'Intră în cont',
  'footer.about': 'Despre UBite',

  // Dish detail
  'dish.notifyOn': 'Te anunțăm când e în meniu',
  'dish.notifyOff': 'Anunță-mă când e în meniu',
  'dish.disclaimer': 'Prețurile și alergenii sunt cele comunicate de cantină, care rămâne sursa lor. Dacă ceva nu corespunde, spune-ne din',
  'dish.disclaimerLink': 'trimite feedback',
  'dish.placeholderPhoto': 'Fotografie orientativă, până primim fotografia cantinei.',
  'dish.calories': '{n} kcal',
  'dish.usualPrice': 'preț obișnuit, nu e în meniul de azi',
  'dish.share': 'Trimite',
  'dish.notFound.title': 'Nu găsim felul acesta',
  'dish.notFound.body': 'Poate a fost scos din catalog. Meniul de azi e pe prima pagină.',
  'dish.notFound.action': 'Înapoi la meniu',
  'dish.allergenSource': 'Cantina Mihail Kogălniceanu',
  'dish.rated': 'Mulțumim pentru notă.',

  // Sign-in (point of need)
  'signin.title': 'Intră în cont',
  'signin.why.favorite': 'Ca să păstrăm felurile tale preferate și să te anunțăm când apar în meniu.',
  'signin.why.rate': 'Ca nota ta să conteze o singură dată pentru fiecare fel.',
  'signin.why.loyalty': 'Ca să ținem socoteala meselor tale. A șasea masă e gratuită.',
  'signin.why.notifications': 'Ca să îți trimitem doar notificările pe care le alegi.',
  'signin.why.account': 'Contul păstrează fidelitatea, favoritele și preferințele tale.',
  'signin.why.staff': 'Intră cu adresa contului creat pentru tine de echipa UBite.',
  'signin.emailStaff': 'Adresa contului',
  'signin.email': 'Adresa ta de la universitate',
  'signin.emailHint': 'Orice adresă a Universității din București, care se termină în unibuc.ro. Nu îți cerem parolă.',
  'signin.sendCode': 'Trimite codul',
  'signin.codeSent': 'Ți-am trimis un cod de șase cifre la {email}. Expiră în zece minute.',
  'signin.demoCode': 'Aceasta e o versiune demo, fără email. Codul tău este {code} și e deja completat.',
  'signin.code': 'Codul din email',
  'signin.verify': 'Intră',
  'signin.otherEmail': 'Altă adresă',
  'signin.resend': 'Trimite alt cod',
  'signin.err.email_domain': 'Folosește adresa de la universitate, care se termină în unibuc.ro.',
  'signin.err.invalid_email': 'Adresa nu pare completă.',
  'signin.err.code_wrong': 'Codul nu e bun. Verifică cele șase cifre.',
  'signin.err.code_expired': 'Codul a expirat. Cere unul nou.',
  'signin.err.code_locked': 'Prea multe încercări. Cere un cod nou.',
  'signin.err.slow_down': 'Mai așteaptă {s} secunde și încearcă din nou.',
  'signin.err.too_many_codes': 'Ai cerut prea multe coduri. Încearcă din nou peste 15 minute.',
  'signin.err.rate_limited': 'Prea multe încercări de pe acest dispozitiv. Încearcă din nou peste 15 minute.',
  'signin.err.mail_unavailable': 'Nu putem trimite emailuri acum. Încearcă mai târziu.',
  'signin.welcome': 'Ai intrat în cont.',

  // Feedback
  'feedback.title': 'Părerea ta',
  'feedback.food': 'Cât de mulțumit ești de mâncare?',
  'feedback.app': 'Cât de utilă îți e aplicația?',
  'feedback.missing': 'Ce ți-ar lipsi din aplicație?',
  'feedback.missingHint': 'Opțional. Scrie liber.',
  'feedback.came': 'Ai venit azi la cantină datorită aplicației?',
  'feedback.yes': 'Da',
  'feedback.no': 'Nu',
  'feedback.anon': 'Poți răspunde fără cont. Nu păstrăm cine a trimis.',
  'feedback.send': 'Trimite',
  'feedback.thanks': 'Mulțumim. Ne ajută mult.',
  'feedback.queued': 'Mulțumim. Trimitem răspunsul când revine semnalul.',
  'feedback.empty': 'Răspunde la cel puțin o întrebare.',
  'feedback.scale': '{n} din 5',

  // Install prompt
  'install.title': 'Pune UBite pe ecranul principal',
  'install.body': 'Ca să primești o notificare când e liber. Durează cinci secunde.',
  'install.later': 'Mai târziu',
  'install.add': 'Adaugă',
  'install.ios.title': 'Adaugă UBite pe iPhone',
  'install.ios.ok': 'Am înțeles',

  // Getting the app (Account). {share} {more} {add} {menu} {install} {app} draw the button or
  // the icon the student looks for on the phone.
  'getapp.eyebrow': 'Aplicația',
  'getapp.title': 'Vrei UBite ca aplicație?',
  'getapp.body': 'O pui pe ecranul telefonului și se deschide ca orice aplicație, pe tot ecranul. Nu ai nevoie de magazinul de aplicații.',
  'getapp.install': 'Instalează UBite',
  'getapp.orSteps': 'Sau pas cu pas:',
  'getapp.done': 'Gata. UBite e pe ecranul tău.',
  'getapp.phone': 'Telefonul tău',
  'getapp.inApp': 'Ai deschis pagina din altă aplicație, iar de aici nu se poate instala. Deschide-o în Safari pe iPhone sau în Chrome pe Android.',
  'getapp.ios.1': 'Apasă {share} Partajează în bara Safari.',
  'getapp.ios.1note': 'Nu-l vezi? Apasă întâi {more}.',
  'getapp.ios.2': 'Alege {add} Adaugă pe ecranul principal.',
  'getapp.ios.2note': 'Dacă nu apare, derulează lista în jos.',
  'getapp.ios.3': 'Apasă Adaugă, sus în dreapta.',
  'getapp.ios.4': 'Deschide UBite {app} de pe ecran.',
  'getapp.ios.4note': 'Notificările merg doar din aplicația de pe ecran.',
  'getapp.android.1': 'Apasă {menu} sus în dreapta, în Chrome.',
  'getapp.android.1note': 'În alt browser, deschide meniul lui.',
  'getapp.android.2': 'Alege {install} Instalează aplicația.',
  'getapp.android.2note': 'Pe unele telefoane scrie Adaugă pe ecranul de pornire.',
  'getapp.android.3': 'Confirmă cu Instalează.',
  'getapp.android.4': 'Deschide UBite {app} de pe ecran.',
  'getapp.android.4note': 'Se deschide pe tot ecranul, fără bara browserului.',

  // Account
  'account.title': 'Contul meu',
  'account.signedOut.title': 'Contul e opțional',
  'account.signedOut.body': 'Meniul și coada sunt la vedere fără cont. Contul păstrează fidelitatea, favoritele și notificările.',
  'account.loyalty': 'Fidelitate',
  'account.rewardCode': 'Vezi codul de recompensă',
  'account.history': 'Istoricul tău',
  'account.visitsMonth': 'Mese luna asta',
  'account.spent': 'Cheltuit luna asta',
  'account.saved': 'Economisit prin fidelitate',
  'account.favoriteDish': 'Felul preferat',
  'account.byDay': 'Ce ai mâncat, pe zile',
  'account.noVisits': 'Încă nu ai adăugat niciun bon. Primul bon e prima bulină.',
  'account.spendUnavailable': 'Suma apare când bonul se citește complet.',
  'account.favorites': 'Favorite',
  'account.noFavorites': 'Apasă inima de lângă un fel și îl găsești aici.',
  'account.diet': 'Preferință alimentară',
  'account.dietHint': 'Filtrăm meniul automat. Poți vedea oricând tot meniul dintr-un tap.',
  'account.notifications': 'Notificări',
  'account.n.menu_published': 'Meniul e publicat',
  'account.n.favorite_today': 'Felul tău preferat e azi',
  'account.n.quiet_now': 'E liber acum',
  'account.n.one_from_free': 'Mai ai o masă până la cea gratuită',
  'account.window': '„E liber acum” te caută doar între {from} și {to}.',
  'account.windowChange': 'Schimbă intervalul',
  'account.windowFrom': 'De la',
  'account.windowTo': 'Până la',
  'account.pushOff': 'Notificările nu sunt pornite pe acest telefon.',
  'account.pushEnable': 'Pornește notificările',
  'account.pushOn': 'Notificările sunt pornite pe acest telefon.',
  'account.pushDenied': 'Notificările sunt blocate din setările browserului.',
  'account.pushIos': 'Pe iPhone, notificările merg după ce pui UBite pe ecranul principal.',
  'account.pushUnsupported': 'Browserul acesta nu primește notificări.',
  'account.pushNotConfigured': 'Notificările nu sunt încă active pe server.',
  'account.pushTest': 'Trimite o notificare de test',
  'account.pushTestSent': 'Am trimis-o. Apare pe telefon în câteva secunde.',
  'account.pushTestNone': 'Nu am găsit acest telefon. Pornește notificările din nou.',
  'account.language': 'Limbă',
  'account.theme': 'Aspect',
  'account.theme.system': 'Ca telefonul',
  'account.theme.light': 'Zi',
  'account.theme.dark': 'Noapte',
  'account.tools': 'Unelte',
  'account.tools.staff': 'Editorul de meniu',
  'account.tools.dashboard': 'Raportul DCCAS',
  'account.tools.admin': 'Administrare',
  'account.signOut': 'Ieși din cont',
  'account.delete': 'Șterge contul',
  'account.delete.title': 'Ștergi contul?',
  'account.delete.body': 'Ștergem adresa, cardul de fidelitate, favoritele și notificările. Notele și feedbackul rămân, fără numele tău. Nu se poate anula.',
  'account.delete.confirm': 'Da, șterge contul',
  'account.deleted': 'Contul a fost șters.',
  'account.signedOutToast': 'Ai ieșit din cont.',
  'account.email': 'Adresa',

  // Card (loyalty)
  'card.title': 'Cardul de fidelitate',
  'card.showAtTill': 'Arată codul la casă',
  'card.code': 'Codul mesei gratuite',
  'card.earned': 'Câștigată pe {date}',
  'card.changesIn': 'se schimbă în {s}s',
  'card.qrCard': 'Codul cardului tău',
  'card.qrCardHint': 'La casă, casierul îl poate scana ca să confirme vizita de azi.',
  'card.how.title': 'Cum funcționează',
  'card.how.1': 'Cere bonul fiscal la casă și fotografiază-l în aplicație.',
  'card.how.2': 'Fiecare zi cu bon e o bulină. Una pe zi.',
  'card.how.3': 'La cinci buline, a șasea masă e gratuită. Arată codul la casă.',
  'card.offline': 'Codul merge și fără internet.',
  'card.soft': 'Masa gratuită se acordă de cantină, după acordul DCCAS.',

  // Add a visit
  'visit.title': 'Adaugă o vizită',
  'visit.intro': 'Cere bonul la casă și fotografiază-l. Fiecare bon e o bulină pe cardul de fidelitate.',
  'visit.frame': 'Încadrează bonul fiscal în chenar. Nu e nevoie să fie perfect.',
  'visit.take': 'Fotografiază bonul',
  'visit.reading': 'Citim bonul…',
  'visit.privacy': 'Păstrăm doar data, suma și numărul bonului. Fotografia nu se salvează.',
  'visit.read': 'Am citit',
  'visit.date': 'Data',
  'visit.total': 'Sumă',
  'visit.number': 'Bon',
  'visit.items': 'Ce ai luat',
  'visit.retake': 'Fă altă poză',
  'visit.confirm': 'Adaugă vizita',
  'visit.unreadable': 'Nu am putut citi bonul. Încearcă o poză mai apropiată, cu bonul drept și bine luminat.',
  'visit.manual': 'Scriu eu numărul și suma',
  'visit.manualTitle': 'Scrie datele de pe bon',
  'visit.manualNumber': 'Numărul bonului',
  'visit.manualNumberHint': 'Apare lângă „Bon fiscal nr.”',
  'visit.manualTotal': 'Totalul',
  'visit.recorded': 'Vizită adăugată · {filled} din 5',
  'visit.recordedNoPoint': 'Bon adăugat. Punctul de azi îl aveai deja.',
  'visit.reward': 'Ai o masă gratuită. Arată codul la casă.',
  'visit.err.duplicate_receipt': 'Bonul acesta a fost deja adăugat.',
  'visit.err.receipt_not_today': 'Bonul nu e de azi. Adaugă bonul în ziua în care ai mâncat.',
  'visit.err.receipt_outside_hours': 'Ora de pe bon e în afara programului cantinei.',
  'visit.err.receipt_other_shop': 'Bonul nu pare să fie de la cantină. Se adaugă doar bonurile cantinei.',
  'visit.err.closed': 'Bonul se adaugă în ziua mesei, în jurul programului cantinei.',
  'visit.err.draft_expired': 'A trecut prea mult timp. Fotografiază bonul din nou.',
  'visit.err.feature_off': 'Fidelitatea nu e încă pornită.',
  'visit.offline': 'Ai nevoie de internet ca să adaugi bonul. Păstrează-l până revine semnalul.',
  'visit.signIn': 'Intră în cont ca să adaugi bonul.',

  // Privacy
  'privacy.title': 'Confidențialitate',
  'privacy.draft': 'Text de lucru, în curs de aprobare de către Universitatea din București.',

  // About
  'about.title': 'Despre UBite',
  'about.next': 'Înainte',
  'about.start': 'Începe',
  'about.skip': 'Sari peste',
  'about.step': 'Pasul {n} din {total}',
  'about.s1.title': 'Cantina Universității, în buzunar',
  'about.s1.body': 'Meniul zilei, coada de acum și ce spun colegii despre fiecare fel.',
  'about.s2.title': 'Vezi meniul înainte să cobori',
  'about.s2.body': 'Se publică de obicei până la 10:30. Îl găsești și fără internet.',
  'about.s3.title': 'Știi cât aștepți, în minute',
  'about.s3.body': 'Estimarea vine din rapoartele colegilor și îți arată mereu cât e de proaspătă.',
  'about.credit': 'Desenul Universității de pe prima pagină e făcut după o fotografie de Joe Mabel (CC BY 3.0).',
  'about.photoCredit': 'Fotografia sălii de mese: Universitatea din București.',

  // Offline banner
  'offline.updated': 'Actualizat la {time}',
};

export type StringKey = keyof typeof ro;

export const en: Record<StringKey, string> = {
  'nav.menu': 'Menu',
  'nav.card': 'Loyalty',
  'nav.visit': 'Receipt',
  'nav.account': 'Account',
  'nav.label': 'Navigation',
  'header.lang': 'Change language',
  'header.notifications': 'Notifications',
  'header.account': 'My account',
  'header.top': 'Back to top',
  'common.back': 'Back',
  'common.skip': 'Skip to content',
  'common.close': 'Close',
  'common.retry': 'Try again',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.lei': 'lei',
  'common.min': 'min',
  'common.loading': 'Loading…',
  'common.unavailable': 'Information not available',
  'common.offlineNeeded': 'You need an internet connection for this.',
  'common.errorGeneric': 'We could not do that right now. Try again in a minute.',
  'update.available': 'A new version of the app is ready.',
  'update.reload': 'Reload',

  'mini.low': 'Short queue',
  'mini.moderate': 'Moderate queue',
  'mini.high': 'Long queue',
  'mini.closed': 'Closed',
  'mini.none': 'No estimate',

  'closed.today': 'today at {time}',
  'closed.tomorrow': 'tomorrow at {time}',
  'closed.weekday': '{day} at {time}',
  'closed.unknown': 'soon',

  'home.picks': 'What people are eating today',
  'home.picksMeta': 'by rating',
  'home.spotRail': 'Highlights',
  'home.spotDots': 'Choose a card',
  'home.spotDot': 'Card {n} of {total}',
  'spot.offline.eyebrow': 'No internet',
  'spot.offline.title': 'Showing the saved menu. Your report goes out by itself when the signal is back.',
  'spot.closed.eyebrow': 'The canteen is closed',
  'spot.closed.title': 'We open {when}. The menu usually appears by 10:30.',
  'spot.tip.eyebrow': 'Tip for {weekday}',
  'spot.tip.title': 'At {quietTime} you wait about {quiet}. At {busyTime}, about {busy}.',
  'spot.tip.action': 'See the hours',
  'spot.loyalty.eyebrow': 'Loyalty',
  'spot.loyalty.title': 'One more visit and your next meal is free.',
  'spot.loyalty.action': 'See the card',
  'spot.reward.title': 'You have a free meal. Show the code at the till.',
  'spot.report.eyebrow': 'Help the others',
  'spot.report.title': 'Say how long you queued. It takes two seconds.',
  'spot.report.action': 'Report',
  'spot.alert.eyebrow': "Tomorrow's menu",
  'spot.alert.title': 'It usually appears by 10:30. We will let you know.',
  'spot.alert.action': 'Notify me',
  'spot.alert.on': 'On',
  'spot.feedback.eyebrow': 'Your opinion',
  'spot.feedback.title': 'Four questions, thirty seconds. It helps us make the app better.',
  'spot.feedback.action': 'Answer',

  'menu.title': "Today's menu",
  'menu.filters': 'Dietary filters',
  'menu.seeAll': 'See the whole menu',
  'menu.savedFilter': 'Your saved filter is on.',
  'menu.staleLabel': "Today's menu is not out yet. Showing the menu from {date}.",
  'menu.empty.title': "Today's menu is not out yet",
  'menu.empty.body': 'It usually appears by 10:30. Come back a little later.',
  'menu.noResults.title': 'No dish matches the filters',
  'menu.noResults.body': "Remove a filter to see all of today's menu.",
  'menu.noResults.action': 'Clear filters',
  'menu.error.title': 'We could not load the menu',
  'menu.error.body': 'Check your connection and try again.',
  'menu.cached': 'Updated at {time}',

  'loyalty.addReceipt': 'Add receipt',

  'report.title': 'How long did you wait?',
  'report.other': 'Another time',
  'report.minutesLabel': 'Minutes in the queue',
  'report.send': 'Send',
  'report.thanks': 'Thanks. The estimate just moved.',
  'report.queued': 'Thanks. Your report goes out when the signal is back.',
  'report.already': 'You already reported this hour. Thanks.',
  'report.closed': 'Reports go in only while the canteen is open.',
  'report.rejected': 'Thanks. Your report differs a lot from what the camera sees, so we did not use it now.',
  'report.invalid': 'Enter a number of minutes between 0 and 120.',

  'typical.title': 'Usually on {weekday}',
  'typical.busy': 'busy at {busy}, quiet at {quiet}',
  'typical.today': 'Usually today',
  'typical.none': 'Not enough data yet to show you the busy hours.',

  'announce.until': 'until {date}',

  'footer.feedback': 'Send feedback',
  'footer.privacy': 'Privacy',
  'footer.account': 'My account',
  'footer.signIn': 'Sign in',
  'footer.about': 'About UBite',

  'dish.notifyOn': 'We will tell you when it is on',
  'dish.notifyOff': 'Notify me when it is on the menu',
  'dish.disclaimer': 'Prices and allergens are as stated by the canteen, which remains their source. If something does not match, tell us through',
  'dish.disclaimerLink': 'send feedback',
  'dish.placeholderPhoto': "Illustrative photo, until the canteen's own arrives.",
  'dish.calories': '{n} kcal',
  'dish.usualPrice': "usual price, not on today's menu",
  'dish.share': 'Share',
  'dish.notFound.title': 'We cannot find this dish',
  'dish.notFound.body': "It may have left the catalogue. Today's menu is on the first page.",
  'dish.notFound.action': 'Back to the menu',
  'dish.allergenSource': 'Cantina Mihail Kogălniceanu',
  'dish.rated': 'Thanks for rating.',

  'signin.title': 'Sign in',
  'signin.why.favorite': 'So we can keep your favourite dishes and tell you when they are on the menu.',
  'signin.why.rate': 'So your rating counts once for each dish.',
  'signin.why.loyalty': 'So we can keep count of your meals. Every sixth one is free.',
  'signin.why.notifications': 'So we send you only the notifications you choose.',
  'signin.why.account': 'Your account keeps your loyalty card, favourites and preferences.',
  'signin.why.staff': 'Sign in with the address the UBite team set up for you.',
  'signin.emailStaff': 'Account address',
  'signin.email': 'Your university address',
  'signin.emailHint': 'Any University of Bucharest address, ending in unibuc.ro. No password needed.',
  'signin.sendCode': 'Send the code',
  'signin.codeSent': 'We sent a six-digit code to {email}. It expires in ten minutes.',
  'signin.demoCode': 'This is a demo without email. Your code is {code}, already filled in.',
  'signin.code': 'The code from the email',
  'signin.verify': 'Sign in',
  'signin.otherEmail': 'Another address',
  'signin.resend': 'Send another code',
  'signin.err.email_domain': 'Use your university address, ending in unibuc.ro.',
  'signin.err.invalid_email': 'The address does not look complete.',
  'signin.err.code_wrong': 'That code is not right. Check the six digits.',
  'signin.err.code_expired': 'The code expired. Ask for a new one.',
  'signin.err.code_locked': 'Too many attempts. Ask for a new code.',
  'signin.err.slow_down': 'Wait {s} seconds and try again.',
  'signin.err.too_many_codes': 'You asked for too many codes. Try again in 15 minutes.',
  'signin.err.rate_limited': 'Too many attempts from this device. Try again in 15 minutes.',
  'signin.err.mail_unavailable': 'We cannot send email right now. Try later.',
  'signin.welcome': 'You are signed in.',

  'feedback.title': 'Your opinion',
  'feedback.food': 'How happy are you with the food?',
  'feedback.app': 'How useful is the app to you?',
  'feedback.missing': 'What is missing from the app?',
  'feedback.missingHint': 'Optional. Write freely.',
  'feedback.came': 'Did the app make you come to the canteen today?',
  'feedback.yes': 'Yes',
  'feedback.no': 'No',
  'feedback.anon': 'You can answer without an account. We do not keep who sent it.',
  'feedback.send': 'Send',
  'feedback.thanks': 'Thank you. It helps a lot.',
  'feedback.queued': 'Thank you. We will send it when the signal is back.',
  'feedback.empty': 'Answer at least one question.',
  'feedback.scale': '{n} of 5',

  'install.title': 'Put UBite on your home screen',
  'install.body': 'So you get a notification when it is quiet. It takes five seconds.',
  'install.later': 'Later',
  'install.add': 'Add',
  'install.ios.title': 'Add UBite on iPhone',
  'install.ios.ok': 'Got it',

  'getapp.eyebrow': 'The app',
  'getapp.title': 'Want UBite as an app?',
  'getapp.body': 'Put it on your home screen and it opens like any app, full screen. No app store needed.',
  'getapp.install': 'Install UBite',
  'getapp.orSteps': 'Or step by step:',
  'getapp.done': 'Done. UBite is on your home screen.',
  'getapp.phone': 'Your phone',
  'getapp.inApp': 'You opened this page inside another app, which cannot install it. Open it in Safari on iPhone or in Chrome on Android.',
  'getapp.ios.1': 'Tap {share} Share in the Safari bar.',
  'getapp.ios.1note': 'Can’t see it? Tap {more} first.',
  'getapp.ios.2': 'Choose {add} Add to Home Screen.',
  'getapp.ios.2note': 'If it is not there, scroll the list down.',
  'getapp.ios.3': 'Tap Add, top right.',
  'getapp.ios.4': 'Open UBite {app} from your home screen.',
  'getapp.ios.4note': 'Notifications only work from the app on your home screen.',
  'getapp.android.1': 'Tap {menu} top right, in Chrome.',
  'getapp.android.1note': 'In another browser, open its menu.',
  'getapp.android.2': 'Choose {install} Install app.',
  'getapp.android.2note': 'Some phones say Add to Home screen instead.',
  'getapp.android.3': 'Confirm with Install.',
  'getapp.android.4': 'Open UBite {app} from your home screen.',
  'getapp.android.4note': 'It opens full screen, without the browser bar.',

  'account.title': 'My account',
  'account.signedOut.title': 'An account is optional',
  'account.signedOut.body': 'The menu and the queue are open to everyone. An account keeps your loyalty card, favourites and notifications.',
  'account.loyalty': 'Loyalty',
  'account.rewardCode': 'See the reward code',
  'account.history': 'Your history',
  'account.visitsMonth': 'Meals this month',
  'account.spent': 'Spent this month',
  'account.saved': 'Saved through loyalty',
  'account.favoriteDish': 'Favourite dish',
  'account.byDay': 'What you ate, by day',
  'account.noVisits': 'No receipts yet. Your first receipt is your first dot.',
  'account.spendUnavailable': 'The amount appears when a receipt is read in full.',
  'account.favorites': 'Favourites',
  'account.noFavorites': 'Tap the heart next to a dish and you will find it here.',
  'account.diet': 'Dietary preference',
  'account.dietHint': 'We filter the menu for you. You can always see the whole menu in one tap.',
  'account.notifications': 'Notifications',
  'account.n.menu_published': 'The menu is out',
  'account.n.favorite_today': 'Your favourite is on today',
  'account.n.quiet_now': 'It is quiet now',
  'account.n.one_from_free': 'One meal from a free one',
  'account.window': '“It is quiet now” only looks between {from} and {to}.',
  'account.windowChange': 'Change the window',
  'account.windowFrom': 'From',
  'account.windowTo': 'To',
  'account.pushOff': 'Notifications are not on for this phone.',
  'account.pushEnable': 'Turn notifications on',
  'account.pushOn': 'Notifications are on for this phone.',
  'account.pushDenied': 'Notifications are blocked in the browser settings.',
  'account.pushIos': 'On iPhone, notifications work once UBite is on your home screen.',
  'account.pushUnsupported': 'This browser does not receive notifications.',
  'account.pushNotConfigured': 'Notifications are not active on the server yet.',
  'account.pushTest': 'Send a test notification',
  'account.pushTestSent': 'Sent. It shows up on the phone in a few seconds.',
  'account.pushTestNone': 'We could not find this phone. Turn notifications on again.',
  'account.language': 'Language',
  'account.theme': 'Appearance',
  'account.theme.system': 'Like the phone',
  'account.theme.light': 'Day',
  'account.theme.dark': 'Night',
  'account.tools': 'Tools',
  'account.tools.staff': 'Menu editor',
  'account.tools.dashboard': 'DCCAS report',
  'account.tools.admin': 'Administration',
  'account.signOut': 'Sign out',
  'account.delete': 'Delete my account',
  'account.delete.title': 'Delete your account?',
  'account.delete.body': 'We delete your address, loyalty card, favourites and notifications. Ratings and feedback stay, without your name. This cannot be undone.',
  'account.delete.confirm': 'Yes, delete it',
  'account.deleted': 'Your account was deleted.',
  'account.signedOutToast': 'You are signed out.',
  'account.email': 'Address',

  'card.title': 'Loyalty card',
  'card.showAtTill': 'Show the code at the till',
  'card.code': 'Free meal code',
  'card.earned': 'Earned on {date}',
  'card.changesIn': 'changes in {s}s',
  'card.qrCard': 'Your card code',
  'card.qrCardHint': 'At the till, the cashier can scan it to confirm today’s visit.',
  'card.how.title': 'How it works',
  'card.how.1': 'Ask for the fiscal receipt at the till and photograph it in the app.',
  'card.how.2': 'Each day with a receipt is a dot. One a day.',
  'card.how.3': 'At five dots, the sixth meal is free. Show the code at the till.',
  'card.offline': 'The code works without internet too.',
  'card.soft': 'The free meal is given by the canteen, as agreed with DCCAS.',

  'visit.title': 'Add a visit',
  'visit.intro': 'Ask for the receipt at the till and photograph it. Each receipt is a dot on your loyalty card.',
  'visit.frame': 'Fit the fiscal receipt in the frame. It does not need to be perfect.',
  'visit.take': 'Photograph the receipt',
  'visit.reading': 'Reading the receipt…',
  'visit.privacy': 'We keep only the date, the total and the receipt number. The photo is not stored.',
  'visit.read': 'We read',
  'visit.date': 'Date',
  'visit.total': 'Total',
  'visit.number': 'Receipt',
  'visit.items': 'What you had',
  'visit.retake': 'Take another photo',
  'visit.confirm': 'Add the visit',
  'visit.unreadable': 'We could not read the receipt. Try a closer photo, with the receipt straight and well lit.',
  'visit.manual': 'I will type the number and total',
  'visit.manualTitle': 'Type what the receipt says',
  'visit.manualNumber': 'Receipt number',
  'visit.manualNumberHint': 'Next to “Bon fiscal nr.”',
  'visit.manualTotal': 'Total',
  'visit.recorded': 'Visit added · {filled} of 5',
  'visit.recordedNoPoint': 'Receipt added. You already had today’s dot.',
  'visit.reward': 'You have a free meal. Show the code at the till.',
  'visit.err.duplicate_receipt': 'This receipt was already added.',
  'visit.err.receipt_not_today': 'The receipt is not from today. Add it on the day you ate.',
  'visit.err.receipt_outside_hours': 'The time on the receipt is outside the canteen’s hours.',
  'visit.err.receipt_other_shop': 'This does not look like a canteen receipt. Only the canteen’s receipts count.',
  'visit.err.closed': 'Receipts are added on the day, around the canteen’s hours.',
  'visit.err.draft_expired': 'Too much time passed. Photograph the receipt again.',
  'visit.err.feature_off': 'Loyalty is not switched on yet.',
  'visit.offline': 'You need internet to add a receipt. Keep it until the signal is back.',
  'visit.signIn': 'Sign in to add a receipt.',

  'privacy.title': 'Privacy',
  'privacy.draft': 'Working draft, awaiting approval by the University of Bucharest.',

  'about.title': 'About UBite',
  'about.next': 'Next',
  'about.start': 'Start',
  'about.skip': 'Skip',
  'about.step': 'Step {n} of {total}',
  'about.s1.title': 'The University canteen, in your pocket',
  'about.s1.body': "Today's menu, the queue right now and what others say about each dish.",
  'about.s2.title': 'See the menu before you walk down',
  'about.s2.body': 'It is usually out by 10:30. You can see it offline too.',
  'about.s3.title': 'Know how long you will wait, in minutes',
  'about.s3.body': 'The estimate comes from other students’ reports and always shows how fresh it is.',
  'about.credit': 'The drawing of the University on the home page is after a photo by Joe Mabel (CC BY 3.0).',
  'about.photoCredit': 'Photo of the dining hall: University of Bucharest.',

  'offline.updated': 'Updated at {time}',
};
